import { OrganizationLevel } from '@/organizations/levels/models/org-level-models';
import { AbstractRepository } from '@/repositories/abstract-repository';

export class OrgLevelsRepository extends AbstractRepository<OrganizationLevel> {
    readonly endpoint = 'organizations/levels';
}
